import { useState } from 'react';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import clsx from 'clsx';

import LearnMoreModal from './learn-more-modal';

type Props = {
  id?: string;
  title: string;
  subtitle?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  itemData?: any;
  showAssetBtn: boolean;
  assignButton?: React.ReactNode;
};

const useStyles = makeStyles(() => ({
  assetContainer: {
    border: '1px solid #D3D3D3',
    margin: 10,
    flexDirection: 'row',
    minHeight: '55px',
  },
  assetInfoContainer: {
    overflow: 'hidden',
    paddingLeft: 10,
    padding: '5px 0px 5px 5px',
  },
  assetInfoContainerUnassignable: {
    width: '98%',
  },
  assetSubtitle: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    fontStyle: 'italic',
  },
  assetLink: {
    color: '#44D2F2',
    cursor: 'pointer',
    textDecoration: 'underline',
  },
  assetAssignContainer: {
    float: 'right',
    textAlign: 'right',
    whiteSpace: 'nowrap',
    padding: '10px 10px 5px 5px',
  },
}));

const Asset = ({ id, title, subtitle, showAssetBtn, itemData, assignButton }: Props) => {
  const classes = useStyles();
  const [showModal, setShowModal] = useState(false);
  const handleLearnMoreClick = () => {
    setShowModal(true);
  };

  return (
    <div className={classes.assetContainer}>
      {assignButton ? <div className={classes.assetAssignContainer}>{assignButton}</div> : ''}
      <div
        className={clsx(
          classes.assetInfoContainer,
          !assignButton && classes.assetInfoContainerUnassignable,
        )}
      >
        <Typography variant="body2">{title}</Typography>
        <Typography variant="body2" className={classes.assetSubtitle}>
          {subtitle}
        </Typography>
        {showAssetBtn && (
          <Typography variant="body2" className={classes.assetLink} onClick={handleLearnMoreClick}>
            Learn More
          </Typography>
        )}
      </div>
      <LearnMoreModal
        id={id}
        showModal={showModal}
        setShowModal={setShowModal}
        onExitClick={() => setShowModal(false)}
        title={title}
        items={itemData}
      />
    </div>
  );
};

export default Asset;
